<template>
  <v-row class="px-5 pb-5" no-gutters>
    <v-row class="unsubscribe" align="center" justify="center"  no-gutters>
      <v-col cols="12">
        <h1 class="text-center">I am sorry to see you go, <br/> au revoir!</h1>
        <unsubscribe-form
          v-show="!unsubscribeSubmitted"
          :email="email"
          @submitted="onUnsubscribe"
        ></unsubscribe-form>
        <v-alert
          type="success"
          v-if="success"
        >You have successfully been unsubscribed</v-alert>
      </v-col>
    </v-row>
  </v-row>
</template>

<script>
import {
  VAlert,
  VCol,
  VRow,
} from 'vuetify/lib'
import UnsubscribeForm from '@/components/UnsubscribeForm'

export default {
  components: {
    UnsubscribeForm,
    VAlert,
    VCol,
    VRow,
  },
  data: () => ({
    success: false,
    unsubscribeSubmitted: false
  }),
  methods: {
    onUnsubscribe() {
      this.success = true
      this.unsubscribeSubmitted = false
    }
  },
  props: {
    email: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>
.unsubscribe {
  margin-top: 5px;
}
</style>
